module.exports = __webpack_public_path__ + "img/default-google-map.ef87affa.png";